import styled from "styled-components"

export const CheckableContainer = styled.div`
  display: flex;
  align-items: center;

  padding-top: 2px;
  padding-bottom: 2px;

  user-select: none;
`
